export const zoneIcon = {
    IT: "IT",
    EU: "EU",
    INT: "INT"
}

export const trafficType = {
    VOCE: "VOCE",
    DATI: "DATI",
    SMS: "SMS",
}